import { AxiosError } from "axios"
import Swal from "sweetalert2"

type TpreConfirmDelete = {
  uuid: string
  promise: (uuid: string) => Promise<any>
  resource: string
}

export const preConfirmDelete = async ({ uuid, promise, resource }: TpreConfirmDelete) => {
  try {
    Swal.showLoading()
    const response = await promise(uuid)
    const { status, msg } = response.data
    if (!status) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: (msg as string) || `Error deleting ${resource}`,
        confirmButtonText: "Continue",
      })
      throw new Error(msg as string)
    }
    return new Promise((resolve) => resolve(true))
  } catch (error: any) {
    if (error instanceof AxiosError) {
      if (error.response?.data) {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: `Error deleting ${resource}`,
          confirmButtonText: "Continue",
        })
        return new Promise((resolve) => resolve(false))
      }
    }
    throw error
  }
}

type TpreConfirmDeleteExpress = {
  promise: (id: string) => Promise<any>
  resource: string
  id: string
}

export const preConfirmDeleteExpress = async ({ id, promise, resource }: TpreConfirmDeleteExpress) => {
  try {
    Swal.showLoading()
    const response = await promise(id)
    const { message } = response.data
    if (!message) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: (message as string) || `Error deleting ${resource}`,
        confirmButtonText: "Continue",
      })
      throw new Error(message as string)
    }
    return new Promise((resolve) => resolve(true))
  } catch (error: any) {
    if (error instanceof AxiosError) {
      const responseError = (error.response?.data || {}) as IExpressError
      if (responseError) {
        Swal.fire({
          icon: "error",
          html: `
          <div>
            <p class="font-bold text-lg capitalize">${responseError.status || "Something went wrong"}</p>
            <p class="mb-5">${responseError.message || `Error deleting ${resource}`}</p>
            <p class="text-gray-500 text-sm">If the problem persists, please contact support.</p>
          </div>
          `,
          // title: responseError.status || "Something went wrong",
          // text: responseError.message || `Error deleting ${resource}`,
          confirmButtonText: "Continue",
        })
        return new Promise((resolve) => resolve(false))
      }
    }
    throw error
  }
}
